import * as S from './Divider.styled'

const Divider = (props) => {
  const { value } = props
  return <S.Divider size={value?.size} bgColor={value?.colour} />
}

export default Divider
